<template>
  <div class="labelItem__content">
    <div class="labeltxts" :class="labelClass" :style="{'min-width':labelWidth}">
      <div>
        <span v-if="required" class="start">*</span>{{ labeltxt ? `${labeltxt}：` : '' }}
      </div>
      <slot name="labeltxt"></slot>
    </div>
    <div class="contents" :class="contentClass"><slot></slot></div>
    <div><slot name="noContents"></slot></div>
  </div>
</template>

<script>
export default {
  name: 'LabelItem',
  props: {
    labeltxt: {
      type: [String],
    },
    required: {
      type: [Boolean],
      default: false,
    },
    labelWidth: {
      type: [String],
      default: '50%',
    },
    labelClass: {
      type: [String],
    },
    contentClass: {
      type: [String],
    },
  },
};
</script>

<style lang="scss" scoped>

::v-deep.labelItem__content {
  display: flex;

  .labeltxts {
    text-align: end;
  }
  .contents {
    text-align: start;
  }
}

</style>
